import axios from 'axios';
import { API_BASE_URL } from 'config/apiConfig';
import { prepareAuthenticatedRequest } from 'services/httpClient';

export interface PerformanceMetricEvent {
  event_id: string;
  kind: 'navigation' | 'route' | 'api' | 'resource' | 'web_vital';
  name: 'page_load' | 'route_settle' | 'route_timeout' | 'request' | 'script' | 'stylesheet' | 'image' | 'font' | 'LCP' | 'FCP' | 'CLS' | 'FID' | 'TTFB';
  route: string;
  endpoint?: string;
  value: number;
  device: 'mobile' | 'tablet' | 'desktop';
  server_ms?: number;
  dns_ms?: number;
  connect_ms?: number;
  ttfb_ms?: number;
  transfer_ms?: number;
  status_code?: number;
}

// Reuse the application's token/cookie and CSRF preparation, but intentionally
// omit its response interceptor: optional telemetry must never end a session.
const transport = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});
transport.interceptors.request.use(prepareAuthenticatedRequest, undefined, { synchronous: true });

export const sendPerformanceMetrics = async (
  events: PerformanceMetricEvent[],
  signal: AbortSignal,
): Promise<void> => {
  await transport.post('/api/performance/', { events }, { signal });
};
